export function calculateMaxZIndex(windows) {
  return windows?.length > 0 ? Math.max(...windows.map((w) => w.zIndex)) : 0;
}
